import baseService from '../utils/axios';

export const getLoggedUser = () => baseService.get('/users/me');

export const getIsAccountAdmin = () => baseService.get('/account/is_admin');

export const getUserMultiAccountTokens = () => baseService.get('/auth/multi_account_tokens');
